<template>
  <main
    class="container is-fluid"
    v-if="error"
  >
    <div class="notification is-danger">
      <template v-if="error instanceof CorpusNotFoundError">
        The project with ID
        <ItemId :item-id="corpusId" />
        does not exist, or you do not have permission to access it.
      </template>
      <template v-else>
        An error occurred while retrieving the project: {{ errorParser(error) }}
      </template>
    </div>
  </main>
  <div
    class="loader mx-auto is-size-2"
    v-else-if="!corporaStore.loaded"
  ></div>
  <div v-else>
    <CorpusHeader :corpus-id="corpusId" />
    <main class="container is-fluid">
      <ElementNavigation
        :corpus-id="corpusId"
        v-model:query="query"
      />
    </main>
  </div>
</template>

<script setup lang="ts">
import { computed, ref, watch } from 'vue'
import { type LocationQueryRaw, useRouter } from 'vue-router'

import CorpusHeader from '@/components/Corpus/Header.vue'
import ItemId from '@/components/ItemId.vue'
import ElementNavigation from '@/components/Navigation/ElementNavigation.vue'
import { errorParser } from '@/helpers'
import { useCorporaStore } from '@/stores'
import { CorpusNotFoundError } from '@/stores/corpora'
import type { UUID } from '@/types'

const { corpusId } = defineProps<{ corpusId: UUID }>()

const router = useRouter()

const query = computed({
  get() {
    return router.currentRoute.value.query
  },
  set(query: LocationQueryRaw) {
    router.push({ ...router.currentRoute, query })
  },
})

const corporaStore = useCorporaStore()
const error = ref<unknown>(null)
watch(
  () => corpusId,
  async (newValue) => {
    try {
      await corporaStore.get(newValue)
      error.value = null
    } catch (err) {
      error.value = err
    }
  },
  { immediate: true },
)
</script>
